export default __webpack_public_path__ + "static/mairlin_2-02e03136cdabc49f6d5a00a4d47ec4d2.webp";